import React from 'react'
import styled, { withTheme } from 'styled-components'

import { CtaButton } from '../../../../../src/ui/buttons/Button.jsx'
import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'

const ButtonWrapper = styled.div`
  display: flex;
  height: 52px;
`

const GetDirectionsButton = withTheme(({ theme, T, onGetDirectionClick }) => {
  return <ButtonWrapper>
    <CtaButton onClick={(e) => {
      e.stopPropagation()
      onGetDirectionClick()
    }} backgroundColor={theme.colors.primaryButton} hoverBackgroundColor={theme.colors.primaryButtonHover} fontColor={theme.colors.primaryButtonText}>
      <ColoredIcon id='directions-filled' fillColor={theme.colors.primaryButtonText} width={24} height={24} />
      {T('flightDetails:Get Directions')}
    </CtaButton>
  </ButtonWrapper>
})

export default GetDirectionsButton
